<template>
  <div class="">
    <div class="menu-holder">
      <div class="title-container menu-title">
        <h3>{{ options.title }}</h3>
      </div>
      <ul>
        <li v-for="(value, name) in options.options" :key="name">
          <div
            v-show="
              activeSpecs[options.title] === name ||
              activeMenu === options.title
            "
          >
            <button
              class="option-button option"
              :class="{
                active: activeSpecs[options.title] === name
              }"
              @click="menuAction(options.title, name)"
            >
              {{ name }}
              <div
                v-show="activeMenu !== options.title && optionCount > 1"
                class="arrow-down"
              ></div>
            </button>
          </div>
        </li>
      </ul>
    </div>

    <div v-show="subMenus.length">
      <div class="menu-holder" v-for="menu in subMenus" :key="menu.title">
        <div class="title-container menu-title">
          <h3>{{ menu.title }}</h3>
        </div>
        <ul>
          <li v-for="option in menu.options" :key="option">
            <div
              v-show="
                activeSpecs[menu.title] === option || activeMenu === menu.title
              "
            >
              <button
                class="option-button option"
                :class="{
                  active: activeSpecs[menu.title] === option
                }"
                @click="submenuAction(menu.title, option)"
              >
                {{ option }}

                <div
                  v-show="activeMenu !== menu.title"
                  class="arrow-down"
                ></div>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false,
      activeMenu: '',
      subMenus:
        this.options.options[this.activeSpecs[this.options.title]]?.submenus ||
        []
    }
  },
  props: ['options', 'activeSpecs'],
  components: {},
  computed: {
    optionCount() {
      return Object.keys(this.options.options).length
    }
  },
  methods: {
    menuAction(title, val) {
      if (this.activeMenu === title) {
        //clear submenu values
        const prevSubMenu = this.options.options[
          this.activeSpecs[this.options.title]
        ].submenus
          ? [
              ...this.options.options[this.activeSpecs[this.options.title]]
                .submenus
            ]
          : []

        prevSubMenu.forEach((menu) => {
          this.$emit('setVal', menu.title, '')
        })

        //set spec value
        this.$emit('setVal', title, val)

        //set submenu(s)
        if (this.options.options[val].submenus) {
          this.subMenus = this.options.options[val].submenus || []
          this.subMenus.forEach((menu) => {
            this.$emit('setVal', menu.title, menu.default)
          })
        }

        //close menu
        this.activeMenu = ''
      } else {
        this.activeMenu = title
      }
    },
    submenuAction(title, val) {
      if (this.activeMenu === title) {
        this.$emit('setVal', title, val)
        this.activeMenu = ''
      } else {
        this.activeMenu = title
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-holder {
  padding-bottom: 10px;
}
.option-button {
  margin-bottom: 4px;
  margin-right: -10px;
}
</style>
